import { COVERGO_ASIA_PRE_PROD } from "../consts.js"

export const pentest_preprod = {
	"pentest-studio.preprod.asia.covergo.cloud": {
		appConfig: {
			tenantId: "pentest_preprod",
			appId: "admin_portal",
		},
		envConfig: COVERGO_ASIA_PRE_PROD,
	},
}
